import {FuseNavigationItem} from '../../@fuse/components/navigation';
/*
types:
basic -> item clicavel de menu com navegação
group -> agrupa sob o menu titulo - sem icone
collapsable -> cria menu que abre e fecha
 */

const basicItem = (id: string, title: string, icon: string, link: string, roles?: string | string[]): FuseNavigationItem => ({
    id,
    title,
    type: 'basic',
    icon,
    link,
    roles,
});

const collapsableItem = (id: string, title: string, icon: string, children: FuseNavigationItem[], roles?: string | string[]): FuseNavigationItem => ({
    id,
    title,
    type: 'collapsable',
    icon,
    children,
    roles,
});

export const defaultNavigation: FuseNavigationItem[] = [
    basicItem('dashboard', 'Dashboard', 'heroicons_outline:home', '/home'),
    basicItem('instancias-glpi', 'Gerenciar Instâncias', 'heroicons_outline:server', '/instancias-glpi', 'instancias-glpi'),
    collapsableItem('atendimento-glpi', 'Atendimento', 'heroicons_outline:ticket', [
        basicItem('chamados-glpi', 'Chamados', 'heroicons_outline:ticket', '/chamados', 'chamados-glpi'),
        basicItem('mudancas-glpi', 'Mudanças', 'heroicons_outline:arrow-path', '/mudancas', 'mudancas-glpi'),
        basicItem('problemas-glpi', 'Problemas', 'heroicons_outline:exclamation-triangle', '/problemas', 'problemas-glpi'),
    ]),
    basicItem('recursos', 'Gerenciar Recursos', 'heroicons_outline:cog-6-tooth', '/recursos', 'recursos'),
    basicItem('relatorios-metricas', 'Gerar Relatórios e Métricas', 'heroicons_outline:chart-bar', '/relatorios-metricas', 'relatorios-metricas'),
    basicItem('parametros', 'Parâmetros de Monitoramento', 'heroicons_outline:adjustments-horizontal', '/parametros', 'parametros'),
    basicItem('controle-funcional', 'Controle Funcional', 'heroicons_outline:document-text', '/controle-funcional', 'controle-funcional'),
    basicItem('logs-requisicoes', 'Logs de Requisições', 'heroicons_outline:clipboard-document-list', '/logs-requisicoes', 'logs-requisicoes'),
    collapsableItem('gestao-usuarios', 'Gestão de Usuários', 'heroicons_outline:users', [
        basicItem('usuarios-sso', 'Usuários SSO', 'heroicons_outline:user-group', '/usuarios', 'usuarios-sso'),
        basicItem('grupos-glpi', 'Grupos', 'heroicons_outline:user-group', '/grupos', 'grupos-glpi'),
    ], ),
    collapsableItem('faq', 'FAQ', 'heroicons_outline:question-mark-circle', [
        basicItem('faq-list', 'Perguntas Frequentes', 'heroicons_outline:document-text', '/faq', 'faq-list'),
        basicItem('faq-categories', 'Categorias', 'heroicons_outline:folder', '/faq-categorias', 'faq-categories'),
    ], ),
];
